import React from "react";

export default ({ onClick, className }) => (
  <button
    onClick={onClick}
    className={className}
    aria-label="Toggle disclaimer message"
    title="Toggle disclaimer message"
  >
    <svg
      width="15"
      height="15"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 0C3.80603 0 0 3.80603 0 8.5C0 13.194 3.80603 17 8.5 17C13.194 17 17 13.194 17 8.5C17 3.80603 13.194 0 8.5 0ZM8.5 15.558C4.6029 15.558 1.44196 12.3971 1.44196 8.5C1.44196 4.6029 4.6029 1.44196 8.5 1.44196C12.3971 1.44196 15.558 4.6029 15.558 8.5C15.558 12.3971 12.3971 15.558 8.5 15.558Z"
        fill="white"
      />
      <path
        d="M7.58932 5.16071C7.58932 5.40225 7.68527 5.63389 7.85607 5.80469C8.02686 5.97548 8.2585 6.07143 8.50004 6.07143C8.74158 6.07143 8.97322 5.97548 9.14401 5.80469C9.3148 5.63389 9.41075 5.40225 9.41075 5.16071C9.41075 4.91918 9.3148 4.68753 9.14401 4.51674C8.97322 4.34595 8.74158 4.25 8.50004 4.25C8.2585 4.25 8.02686 4.34595 7.85607 4.51674C7.68527 4.68753 7.58932 4.91918 7.58932 5.16071V5.16071ZM8.9554 7.28571H8.04468C7.9612 7.28571 7.8929 7.35402 7.8929 7.4375V12.5982C7.8929 12.6817 7.9612 12.75 8.04468 12.75H8.9554C9.03888 12.75 9.10718 12.6817 9.10718 12.5982V7.4375C9.10718 7.35402 9.03888 7.28571 8.9554 7.28571Z"
        fill="white"
      />
    </svg>
  </button>
);
